var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Const } from './provider/lib/const.cls';
import * as Types from '../../types';
import { mapActions } from 'vuex';
import { commonAll } from './lib/commonAll.cls';
import * as commonAllStoreExtensions from './provider/';
import * as moment from 'moment';
import { formatPriceCommon } from '../../store/commomFunction';
var state = __assign({}, commonAllStoreExtensions.stateExt);
var actions = __assign({}, commonAllStoreExtensions.actionsExt);
var mutations = __assign({}, commonAllStoreExtensions.mutationsExt);
var getters = __assign({}, commonAllStoreExtensions.gettersExt);
// new store module definition
var commonAllStore = {
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
};
// main mixin to load the new store module
export var commonAllmixins = {
    created: function () {
        var _store = this.$store;
        if (!(_store && _store.state && _store.state[commonAll.STORE_MODULE_NAME])) {
            try {
                this.$store.registerModule(commonAll.STORE_MODULE_NAME, commonAllStore);
            }
            catch (error) { }
        }
    },
    methods: __assign(__assign({ permissionModule: function (getData) {
            // console.log('innn')
            // this.get_user.permissions = "CONVERSION"
            if (this.get_user.permissions != undefined && this.get_user.permissions != null && this.get_user.permissions != '') {
                var permission_array = [];
                if (this.get_user.permissions.includes(",")) {
                    permission_array = this.get_user.permissions.split(',');
                }
                else {
                    permission_array.push(this.get_user.permissions);
                }
                // console.log(permission_array)
                if (permission_array.includes(getData)) {
                    return true;
                }
                else {
                    return false;
                }
            }
            else {
                return false;
            }
        } }, mapActions({
        _runGetProfileInfo: Const.RUN_GET_PROFILE_INFO,
        _runGenerate2FaQrcode: Const.RUN_GENERATE_2FA_QRCODE,
        _runVerify2FaQrcode: Const.RUN_VERIFY_2FA_QRCODE,
        _runDisable2FaQrcode: Const.RUN_DISABLE_2FA_QRCODE,
        _runGetPaymentMethods: Const.RUN_GET_PAYMENT_METHODS,
        //===================trading Account=================
        // =================notification list========================
        _runGetNotificationList: Const.RUN_GET_NOTIFICATION_LIST,
        _runReadUnreadNotification: Const.RUN_READ_UNREAD_NOTIFICATION,
        // =================notification settings========================
        _runNotificationSettings: Const.RUN_NOTIFICATION_SETTINGS,
        _runNotificationgetSettings: Const.RUN_NOTIFICATION_GET_SETTINGS,
        _runNotificationEnablegetSettings: Const.RUN_NOTIFICATION_ENABLE_GET_SETTINGS,
        _runGetApiKeys: Const.RUN_GET_API_KEYS,
        _runUpdateApiKey: Const.RUN_UPDATE_API_KEYS,
        _runUpdateApiWebook: Const.RUN_UPDATE_API_WEBOOK,
        _rungetWalletMargin: Const.RUN_GET_WALLET_MARGIN,
        _runConfirmWalletTransaction: Const.RUN_CONFIRM_WALLET_TRANSACTION,
        _runGetCryptoAddresses: Const.RUN_GET_CRYPTO_ADDRESSES,
        _runGetBankAddresses: Const.RUN_GET_BANK_ADDRESSES,
        //===================== WATCH LIST ===================
        _runGetWatchList: Const.RUN_GET_WATCH_LIST,
        _runGetNewsList: Const.RUN_GET_NEWS_LIST,
    })), { getCurrName: function (currency) {
            try {
                var list = [];
                list = Object.values(this.$env_var.walletCurrencyList);
                return list.filter(function (val) { return val.symbol == currency; })[0].currency_name;
            }
            catch (e) {
                return '';
            }
        },
        getkeyType: function (currency) {
            try {
                var list = [];
                list = Object.values(this.$env_var.walletCurrencyList);
                return list.filter(function (val) { return val.symbol == currency; })[0].keyType;
            }
            catch (e) {
                return '';
            }
        },
        withdrawLimit: function () {
            if (parseInt(this.get_user.tier) == 1) {
                if (parseInt(this.get_user.lead_type) == 0 && parseInt(this.get_user.step) < 3) {
                    this.$router.push('/individual-step' + (parseInt(this.get_user.step) + 1));
                }
                else if (parseInt(this.get_user.lead_type) == 1 && parseInt(this.get_user.step) < 4) {
                    this.$router.push('/corporate-step' + (parseInt(this.get_user.step) + 1));
                }
            }
            else if (parseInt(this.get_user.tier) == 2) {
                if (this.$route.name != 'account-profile')
                    this.$router.push('/home');
            }
            else if (parseInt(this.get_user.tier) == 3) {
                // this.$router.push({ name: 'help_centre', params: { 'page': 'profile', 'ticketData': '16', 'method_id': '1' } })
                this.$router.push({ name: 'questionnaire' });
            }
        },
        pageName: function (val) {
            this.$parent.pageTxt = val;
        },
        computedCommonFunc: function (getFuncName) {
            try {
                return this.$store.getters[getFuncName];
            }
            catch (ex) {
                return [];
            }
        },
        formatPrice: function (val, isCrypto) {
            return formatPriceCommon(val, isCrypto === true ? true : false);
        },
        formatDate: function (value) {
            /*var data = moment(value).local().format('DD MMM YYYY, h:mm:ss a')
            console.log(value,data)*/
            var data = new Date(value);
            // var t = data.toString()
            // console.log(value,data,data.getTimezoneOffset(),'--',t)
            return moment(data.toUTCString()).format('DD MMM YYYY, h:mm:ss a');
        },
        numberFormat: function (value) {
            if (value) {
                value = value.toString();
                try {
                    if (!isNaN(value)) {
                        return parseInt(value).toLocaleString() + ((value.toString().indexOf('.') != -1) ? ('.' + value.split('.')[1]) : '');
                    }
                    else {
                        return 0;
                    }
                }
                catch (e) {
                    return 0;
                }
                /*var data = value
                // console.log(data);
                if (!isNaN(value) && value.split['.'].toString().indexOf('.') != -1) {
                    // console.log('length',data.toString().split(".")[1],data.toString().split(".")[1].length)
                    data = value //parseFloat(value).toFixed(8)
                }
                // data = parseFloat(value).toFixed(8)
                // return data.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
                return data.toLocaleString()*/
            }
            else {
                return '';
            }
        } }),
    computed: {
        refreshData: function () {
            return this.computedCommonFunc(Const.GET_STATE_REFRESH_DATA);
        },
        get_user: function () {
            return this.computedCommonFunc(Types.GET_USER);
        },
        profileInfo: function () { return this.computedCommonFunc(Const.GET_PROFILE_INFO); },
        GetPaymentMethods: function () { return this.computedCommonFunc(Const.GET_PAYMENT_METHODS); },
        notificationList: function () { return this.computedCommonFunc(Const.GET_NOTIFICATION_LIST); },
        notificationUnreadList: function () { return this.computedCommonFunc(Const.GET_UNREAD_NOTIFICATION_DATA); },
        notificationGetSettings: function () { return this.computedCommonFunc(Const.GET_NOTIFICATION_GET_SETTINGS); },
        notificationEnablegetSettings: function () { return this.computedCommonFunc(Const.GET_NOTIFICATION_ENABLE_GET_SETTINGS); },
        cryptoAddresses: function () { return this.computedCommonFunc(Const.GET_CRYPTO_ADDRESSES); },
        bankAddresses: function () { return this.computedCommonFunc(Const.GET_BANK_ADDRESSES); },
        watchListData: function () { return this.computedCommonFunc(Const.GET_WATCH_LIST); },
        newsList: function () { return this.computedCommonFunc(Const.GET_NEWS_LIST); },
        cryptoNewsList: function () { return this.computedCommonFunc(Const.GET_CRYPTO_NEWS_LIST); },
    }
};
export default commonAllmixins;



//////////////////
// WEBPACK FOOTER
// ./src/plugins/commonAll/index.ts
// module id = null
// module chunks = 